import isArray from './isArray';
import isNull from './isNull';
import isTypeOf from './isTypeOf';
var isObject = function isObject(value) {
  return isTypeOf('object')(value) && !isNull(value) && !isArray(value);
};
export default isObject;